module.exports = "/shared/fonts/bebas.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/bebas.ttf
// module id = 320
// module chunks = 13